// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

import {
  getAuth,
  signInWithRedirect,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  NextOrObserver,
  User,
} from 'firebase/auth';

import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  collection,
  writeBatch,
  query,
  getDocs,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import { Category } from '../../store/categories/category.types';

// 'doc' is use to retreive the documents instance in our firestore database.
// 'getDoc' method is used to get the data form a document.
// 'setDoc' method is used to set the data onto a document.

const firebaseConfig = {
  apiKey: 'AIzaSyDd4wjcyBlFsnw3gAScXYgoIhDuWniA9G8',
  authDomain: 'crwn-clothing-db-908eb.firebaseapp.com',
  projectId: 'crwn-clothing-db-908eb',
  storageBucket: 'crwn-clothing-db-908eb.appspot.com',
  messagingSenderId: '131392946360',
  appId: '1:131392946360:web:7014fc85a134a6f67d344d',
};

// Initialize Firebase
// const firebaseApp = initializeApp(firebaseConfig);
initializeApp(firebaseConfig);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

export const auth = getAuth(); // getAuth() method is used to instantiate the authentication instance. it returns the auth object which containes all the rules of user authentication.

export const signInWithGooglePopup = () =>
  signInWithPopup(auth, googleProvider);

// signInwithPopup will initiate a popup window for sign in, this method needs two atguments, 1st is the auth argument, which defines all the rules of authentication, and the 2nd argument is the authentication provider object which provides the authentication service, this authentication provider service can be google or facebook or any other provider.

export const signInWithGoogleRedirect = () =>
  signInWithRedirect(auth, googleProvider);

export const signInWithGoogleRdirect = () => {
  signInWithRedirect(auth, googleProvider);
};

export const db = getFirestore(); // getFirestore() intantiate the firestore database instance. It is used to instantiate our databes object. Now, 'db' directly points to the firestore database.

export type ObjectToAdd = {
  title: string;
};

export const addCollectionAndDocuments = async <T extends ObjectToAdd>(
  collectionKey: string,
  objectsToAdd: T[]
): Promise<void> => {
  const collectionRef = collection(db, collectionKey); // collection() method creates a collection reference 'collectionRef' same as doc() creates a document reference
  const batch = writeBatch(db); // 'writeBatch()' Creates a write batch, used for performing multiple writes as a single atomic operation. The maximum number of writes allowed in a single WriteBatch is 500.

  objectsToAdd.forEach((object) => {
    const docRef = doc(collectionRef, object.title.toLowerCase());
    batch.set(docRef, object);
  });
  await batch.commit();
  console.log('done');
};

export const getCatogoriesAndDocuments = async (): Promise<Category[]> => {
  const collectionRef = collection(db, 'categories');
  const q = query(collectionRef);

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(
    (docSnapshot) => docSnapshot.data() as Category
  ); // 'querySnapshot.docs' this gives the array of individual document. And then we map over it to get the document data structure. Not the data itself but only the structure of that data.

  //   const categoryMap = querySnapshot.docs.reduce((acc, docSnapshot) => {
  //     const { title, items } = docSnapshot.data();
  //     acc[title.toLowerCase()] = items;
  //     return acc;
  //   }, {});

  //   return categoryMap;
};

export type AdditionalInformation = {
  displayName?: string;
};

export type UserData = {
  createdAt: Date;
  displayName: string;
  email: string;
};

export const createUserDocumentFromAuth = async (
  userAuth: User,
  additionalInformation = {} as AdditionalInformation
): Promise<void | QueryDocumentSnapshot<UserData>> => {
  if (!userAuth) return;

  const userDocRef = doc(db, 'users', userAuth.uid); // 'userDocRef' is the instance of user document model, created by doc() method.
  // doc() takes three arguments, 1st is the database 'db' at which this userDocref instance will be stored. 2nd, it takes the user defined document collection name. And 3rd is the unique identifier to identify the userDocRef instance. Here, we are taking that unique id from userAuth object.

  console.log(userDocRef);
  const userSnapshot = await getDoc(userDocRef); // 'userSnapshot' is kind of like the data. It is a specific object which we get using the getDoc() method. It allows us to access the data from the document.
  console.log(userSnapshot);
  console.log(userSnapshot.exists()); // the exist() method on 'userSnapshot' returns a boolean which tells us if the data is stored on the firestore database or not.

  if (!userSnapshot.exists()) {
    const { displayName, email } = userAuth;
    const createdAt = new Date();

    try {
      await setDoc(userDocRef, {
        displayName,
        email,
        createdAt,
        ...additionalInformation,
      });
    } catch (error) {
      console.log('error creating the user', error);
    }
  }
  // 'setDoc()' is used to set the data onto the document
  // return userDocRef;
  return userSnapshot as QueryDocumentSnapshot<UserData>;
};

export const createAuthUserWithEmailAndPassword = async (
  email: string,
  password: string
) => {
  if (!email || !password) return;
  return await createUserWithEmailAndPassword(auth, email, password);
};

export const signInAuthUserWithEmailAndPassword = async (
  email: string,
  password: string
) => {
  if (!email || !password) return;
  return await signInWithEmailAndPassword(auth, email, password);
};

export const signOutUser = async () => await signOut(auth); // thismethod sign out the user and return undefined, then we can use use 'useState()' hook to set the user data to 'null', this way we can sign out the user.

export const onAuthStateChangedListener = (callback: NextOrObserver<User>) =>
  onAuthStateChanged(auth, callback);

export const getCurrentUser = (): Promise<User | null> => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (userAuth) => {
        unsubscribe();
        resolve(userAuth);
      },
      reject
    );
  });
};
// 'onAuthStateChanged()' is a observable listener, this listener can listen for the change in stream of events and perform some actions based on these changes. Here, this listener, listen to the changes in 'auth' state and as soon as the 'auth' state changes it runs the callback function.

//  'onAuthStateChanged()' this listener fucntion takes two parameters. One is the 'auth' singleton which tracks all the authentication related information and second, is the callback function which we want to run whenever our 'auth' state changes
